import { useEffect, useState } from 'react'
import { Item } from '../../common/snippets'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../common/dropDownOA'
import Datepicker from '../../common/datePicker'
import * as sx from '../../common/stylesInline/report_daily_branch'
import moment from 'moment'
import { focusElemnt, isEmpty, navigation3 } from '../../common/helper'
import { OGCLHeaders, OGCLFilterHeaders } from './contants'
import { accumulateTotals } from '../Reports/NonMovementTable/utilFucntions'
import { TableComponent } from '../../common/TableComponent'
import useToken from '../../helpers/useTokens'
import { GetRequest } from '../../common/api'
import { urls } from '../../common/constants'
import { useAtom, useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../common/jotaiState/globalStateAtoms'
import { AcountingHeading } from './common/AcountingHeading'
import { CargoRoleRightsAtom } from '../../common/jotaiState/commonStateAtoms'
const OGCLReport = () => {
     const reportName = 'OGCL Report'
      const { loginData } = useToken()
      const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
      const { Table1: RoleRightTable1 = [] } = cargoRoleRights
      const [roleRightsData] = RoleRightTable1
      const { AllowViewAllBranchReport, AllowBranchInchargeRights } = { ...roleRightsData }
      const { IsBranchAdmin, IsMTPLAdmin, IsAdmin } = loginData
      const [disableBtn, setDisableBtn] = useState(false)
      const [tableData, setTableData] = useState([])
      const [fromDate, setFromDate] = useState(moment(new Date()))
      const [toDate, setToDate] = useState(moment(new Date()))
    
      const setAlert = useSetAtom(alertAtom)
      const setLoader = useSetAtom(globalLoaderAtom)
    
      // ================= SOURCE =================
      const [stateList, setStateList] = useState([])
      const [selState, setSelState] = useState()
      const [cityList, setCityList] = useState([])
      const [filterdCityList, setFilterdCityList] = useState([])
      const [selCity, setSelCity] = useState()
      const [branchList, setBranchList] = useState([])
      const [filterdBranchList, setFilterdBranchList] = useState([])
      const [selBranch, setSelBranch] = useState()
    
      // ================= DESTINATION =================
      const [destStateList, setDestStateList] = useState([])
      const [destCityList, setDestCityList] = useState([])
      const [filterdDestCityList, setFilterdDestCityList] = useState([])
      const [destBranchList, setDestBranchList] = useState([])
      const [filterdDestBranchList, setFilterdDestBranchList] = useState([])
    
      const [selDestState, setSelDestState] = useState(null)
      const [selDestCity, setSelDestCity] = useState(null)
      const [selDestBranch, setSelDestBranch] = useState(null)
    
      // ================= PAYMENT =================
      const [paymentTypeList, setPaymentTypeList] = useState([])
      const [selPaymentType, setSelPaymentType] = useState(null)
    
      // ================= DEST FILTER HANDLER STORE =================
      const [destFilterHandler, setDestFilterHandler] = useState(() => () => { })
      useEffect(() => {
        if (!isEmpty(cargoRoleRights) && !isEmpty(loginData)) {
          setDisableBtn(!(AllowViewAllBranchReport || AllowBranchInchargeRights || IsBranchAdmin || IsMTPLAdmin || IsAdmin))
        }
      }, [cargoRoleRights, loginData])
      const headers = OGCLHeaders.map((col) => ({
        ...col,
        align: col.align || col.xlCol?.dataType === 'quantity' ? 'right' : 'left',
        exportHead: col.header,
      }))
      const formatTableData = (list) => {
        list = list.map((col, index) => ({
          ...col,
          dataType: 'entry',
          SN: index + 1,
          disabled: true,
          DispatchDate: moment(col.DispatchDate, 'DD-MM-YY', true).format('DD-MM-YYYY'),
          // DispatchDate: moment(col.DispatchDate).format('DD-MM-YYYY'),
        }))
        const grouped = list.reduce((map, curr) => {
          const key = curr.DispatchDate
          if (!map.has(key)) map.set(key, [])
          map.get(key).push(curr)
          return map
        }, new Map())
    
        const numericKeys = OGCLHeaders.reduce((acc, curr) => {
          if (curr.xlCol?.dataType === 'quantity') {
            acc.push(curr.field?.replace(/_view$/, ''))
          }
          return acc
        }, [])
        const makeEmptyRow = () =>
          OGCLHeaders.reduce((acc, h) => {
            acc[h.field] = ''
            return acc
          }, {})
        const formatted = Array.from(grouped.entries()).flatMap(([DispatchDate, items]) => {
          const groupTotal = accumulateTotals(items, numericKeys)
          return [
            ...items,
            {
              ...makeEmptyRow(),
              dataType: 'total',
              [OGCLHeaders[0].field]: `TOTAL: ${DispatchDate}`,
              align: { [OGCLHeaders[0].field]: 'right' },
              colSpan: { [OGCLHeaders[0].field]: 5 },
              ...groupTotal,
            },
          ]
        })
    
        if (grouped.size > 1) {
          const grandTotal = accumulateTotals(
            formatted.filter((row) => row.dataType === 'entry'),
            numericKeys
          )
    
          formatted.push({
            ...makeEmptyRow(),
            dataType: 'total',
            [OGCLHeaders[0].field]: `TOTAL: ${fromDate.format('DD-MM-YYYY')} to ${toDate.format('DD-MM-YYYY')}`,
            align: { [OGCLHeaders[0].field]: 'right' },
            colSpan: { [OGCLHeaders[0].field]: 5 },
            ...grandTotal,
          })
        }
    
        return formatted
      }
      const callFilterAPi = () => {
        if (Math.abs(toDate.diff(fromDate, 'days')) > 31) {
          setAlert({
            show: true,
            msg: 'This report cannot be taken for more than 31 days',
            nextId: '',
          })
          return
        }

        setLoader(true)

        const payload = {
          intFromCityID: 0,
          intFromBranchID: 0,
          intToCityID: 0,
          intToBranchID: 0,
          intCompanyID: loginData?.intCompanyID || 0,
          dtFrom: fromDate.format('YYYY-MM-DD'),
          dtTo: toDate.format('YYYY-MM-DD'),
          strVehicleNo: '--All--',
          intPaymentType: 0,
          LoginUserID: loginData?.intUserID || 0,
          IsOnlyCancelledDispatch: 0,
        }

        GetRequest(urls.getDispatchDetailsFilter, payload)
          .then((res) => {
            if (res.status !== 'Success') throw new Error(res?.ErrMessage || 'Failed')
            const table = res?.Data?.Table || []
            if (!table.length) throw new Error('No Data Found')

            // ================= SOURCE STATE =================
            const stateList = [
              ...new Map(
                table.map((i) => [
                  i.SourceStateID,
                  {
                    SourceStateID: i.SourceStateID,
                    SourceState: i.SourceState,
                  },
                ])
              ).values(),
            ]
            if (stateList.length > 1) {
              stateList.unshift({ SourceStateID: 0, SourceState: 'All' })
            }
            setStateList(stateList)
            const defaultState = stateList[0]
            setSelState(defaultState)

            // ================= SOURCE CITY =================
            const cityList = [
              ...new Map(
                table.map((i) => [
                  i.FromCityID,
                  {
                    SourceStateID: i.SourceStateID,
                    FromCityID: i.FromCityID,
                    FromCityName: i.FromCityName,
                  },
                ])
              ).values(),
            ]
            if (cityList.length > 1) {
              cityList.unshift({ FromCityID: 0, SourceStateID: 0, FromCityName: 'All' })
            }
            setCityList(cityList) 
            setFilterdCityList(cityList)
            const defaultCity = cityList[0]
            setSelCity(defaultCity)

            // ================= SOURCE BRANCH =================
            const branchList = [
              ...new Map(
                table.map((i) => [
                  i.BranchID,
                  {
                    SourceStateID: i.SourceStateID,
                    FromCityID: i.FromCityID,
                    BranchID: i.BranchID,
                    BranchName: i.BranchName,
                  },
                ])
              ).values(),
            ]
            if (branchList.length > 1) {
              branchList.unshift({ BranchID: 0, FromCityID: 0, SourceStateID: 0, BranchName: 'All' })
            }
            setBranchList(branchList)

            setFilterdBranchList(branchList)
            const defaultBranch = branchList[0]
            setSelBranch(defaultBranch)

            // ================= DEST RAW DATA =================
            const destStateRaw = [
              ...new Map(
                table.map((i) => [
                  i.DestinationStateID,
                  {
                    DestinationStateID: i.DestinationStateID,
                    DestinationState: i.DestinationState,
                  },
                ])
              ).values(),
            ]

            const destCityRaw = [
              ...new Map(
                table.map((i) => [
                  i.DispatchedToCityIDFilter,
                  {
                    DestinationStateID: i.DestinationStateID,
                    DispatchedToCityIDFilter: i.DispatchedToCityIDFilter,
                    DispatchedToCityFilter: i.DispatchedToCityFilter,
                  },
                ])
              ).values(),
            ]

            const destBranchRaw = [
              ...new Map(
                table.map((i) => [
                  i.DispatchedToBranchIDFilter,
                  {
                    DestinationStateID: i.DestinationStateID,
                    DispatchedToCityIDFilter: i.DispatchedToCityIDFilter,
                    DispatchedToBranchIDFilter: i.DispatchedToBranchIDFilter,
                    DispatchedToBranchFilter: i.DispatchedToBranchFilter,
                  },
                ])
              ).values(),
            ]

            // ================= APPLY SOURCE → DEST FILTER =================
            const applyDestFilter = (state, city, branch) => {
              // ---- STATE ----
              const filteredStates = destStateRaw.filter(
                (s) => s.DestinationStateID !== state?.SourceStateID
              )
              
              if (filteredStates.length > 1) {
                filteredStates.unshift({ DestinationStateID: 0, DestinationState: 'All' })
              }
              setDestStateList(filteredStates)
              setSelDestState(filteredStates[0])

              // ---- CITY ----
              const filteredCities = destCityRaw.filter(
                (c) => c.DispatchedToCityIDFilter !== city?.FromCityID
              )
              if (filteredCities.length > 1) {
                filteredCities.unshift({ DestinationStateID: 0, DispatchedToCityIDFilter: 0, DispatchedToCityFilter: 'All' })
              }
              setDestCityList(filteredCities)
              setFilterdDestCityList(filteredCities)
              setSelDestCity(filteredCities[0])

              // ---- BRANCH ----
              const filteredBranches = destBranchRaw.filter(
                (b) => b.DispatchedToBranchIDFilter !== branch?.BranchID
              )
              if (filteredBranches.length > 1) {
                filteredBranches.unshift({ DestinationStateID: 0, DispatchedToCityIDFilter: 0, DispatchedToBranchIDFilter: 0, DispatchedToBranchFilter: 'All' })
              }
              setDestBranchList(filteredBranches)
              setFilterdDestBranchList(filteredBranches)
              setSelDestBranch(filteredBranches[0])
            }

            // Initial apply
            applyDestFilter(defaultState, defaultCity, defaultBranch)

            // Save handler for later source changes
            setDestFilterHandler(() => applyDestFilter)

            // ================= PAYMENT TYPE =================
            const paymentTypeList = [
              ...new Map(
                table.map((i) => [
                  i.PaymentTypeInt,
                  {
                    PaymentTypeInt: i.PaymentTypeInt,
                    PaymentType: i.PaymentType,
                  },
                ])
              ).values(),
            ]

            setPaymentTypeList([
              { PaymentTypeInt: 0, PaymentType: 'All' },
              ...paymentTypeList,
            ])
            setSelPaymentType({ PaymentTypeInt: 0, PaymentType: 'All' })
          })
          .catch((err) => {
            setAlert({ show: true, msg: err.message, nextId: '' })
          })
          .finally(() => setLoader(false))
      }
  const fetchTableData = () => {
    const diffDays = Math.abs(toDate.diff(fromDate, 'days'))
    const isAllSelected = selCity.FromCityID === 0 || selBranch.BranchID === 0 || selDestCity.DispatchedToCityIDFilter === 0 || selDestBranch.DispatchedToBranchIDFilter === 0
    if (isAllSelected && diffDays > 15) {
      setAlert({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: '' })
      return
    } else if (!isAllSelected && diffDays > 31) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
      return
    } else if (!selState?.SourceState || !selCity?.FromCityName || !selBranch?.BranchName) {
      setAlert({ show: true, msg: 'Please select state, city and branch', nextId: '' })
      return
    }
    setLoader(true)
    const data = {
      intCompanyID: loginData.intCompanyID,
      dtFrom: fromDate.format('YYYY-MM-DD'),
      dtTo: toDate.format('YYYY-MM-DD'),
      intFromCityID: selCity.FromCityID,
      intFromBranchID: selBranch.BranchID,
      intToCityID: selDestCity.DispatchedToCityIDFilter,
      intToBranchID: selDestBranch.DispatchedToBranchIDFilter,
      strVehicleNo: '--All--',
      intPaymentType: selPaymentType.PaymentTypeInt || 0,
      LoginUserID: loginData.intUserID,
      IsOnlyCancelledDispatch: 0,
    }
    GetRequest(urls.getDispatchDetailsFilter, data)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table1) || res.Data.Table1.length === 0) {
          throw new Error('No Data Found')
        }
        const data = formatTableData(res.Data.Table1)
        const reportPayload = {
          reportName,
          criteriaHeaders: OGCLFilterHeaders,
          criteriaData: [filterData],
          tableData: data,
          mainHeader: headers,
        }

        const rid = Date.now().toString()

        if (!window.generatedReports) {
          window.generatedReports = {}
        }

        window.generatedReports[rid] = reportPayload

        window.open(`/view-report?rid=${rid}`, "_blank")
        // setTableData(data)
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
      // ================= FILTER META DATA ================
      const filterData = {
        fromDate: fromDate.format('DD-MM-YYYY'),
        toDate: toDate.format('DD-MM-YYYY'),
        selState: selState?.SourceState,
        selCity: selCity?.FromCityName,
        selBranch: selBranch?.BranchName,
        selDestState: selDestState?.DestinationState,
        selDestCity: selDestCity?.DispatchedToCityFilter,
        selDestBranch: selDestBranch?.DispatchedToBranchFilter,
        selPaymentType: selPaymentType?.PaymentType,
        dataType: 'entry',
      }
      // ================= SOURCE HANDLERS =================
      const handleStateChange = (val) => {
        setSelState(val)
        const cities = val.SourceStateID === 0 ? cityList : cityList.filter((c) => c.SourceStateID === val.SourceStateID)
        if (cities.length > 1 && val.SourceStateID !== 0) {
          cities.unshift({ FromCityName: 'All', FromCityID: 0 })
        }
        setFilterdCityList(cities)
        const firstCity = cities[0]
        setSelCity(firstCity)


        const branches =
          val.SourceStateID === 0
            ? branchList
            : firstCity.FromCityID === 0
              ? branchList.filter((branch) => branch.SourceStateID === val.SourceStateID)
              : branchList.filter((branch) => branch.FromCityID === firstCity.FromCityID)
        if (branches.length > 1 && val.SourceStateID !== 0) {
          branches.unshift({ BranchName: 'All', BranchID: 0 })
        }
        setFilterdBranchList(branches)
        const firstBranch = branches[0]
        setSelBranch(firstBranch)

        destFilterHandler(val, firstCity, firstBranch)
      }
      const handleCityChange = (val) => {
        setSelCity(val)
        const cityBranches =
          val.FromCityID === 0
            ? selState.SourceStateID === 0
              ? branchList
              : branchList.filter((branch) => branch.SourceStateID === selState.SourceStateID)
            : branchList.filter((branch) => branch.FromCityID === val.FromCityID)
        if (cityBranches.length > 1 && (val.FromCityID !== 0 || selState.SourceStateID !== 0)) {
          cityBranches.unshift({ BranchName: 'All', BranchID: 0 })
        }
        setFilterdBranchList(cityBranches)
        const firstBranch = cityBranches[0]
        setSelBranch(firstBranch)

        destFilterHandler(selState, val, firstBranch)
      }
    
      const handleSourceBranchChange = (val) => {
        setSelBranch(val)
        destFilterHandler(selState, selCity, val)
      }
      // ================= DEST HANDLERS ===================
      const handleDestStateChange = (val) => {
        setSelDestState(val)
    
        // All selected
        if (val.DestinationStateID === 0) {
          const allCities = destCityList.filter(
            (c) => c.DispatchedToCityIDFilter === 0
          )
          setFilterdDestCityList(allCities)
          setSelDestCity(allCities[0])
    
          const allBranches = destBranchList.filter(
            (b) => b.DispatchedToBranchIDFilter === 0
          )
          setFilterdDestBranchList(allBranches)
          setSelDestBranch(allBranches[0])
          return
        }
    
        const cities = destCityList.filter(
          (c) => c.DestinationStateID === val.DestinationStateID
        )
        const citiesWithAll = [
          {
            DestinationStateID: val.DestinationStateID,
            DispatchedToCityIDFilter: 0,
            DispatchedToCityFilter: 'All',
          },
          ...cities,
        ]
        setFilterdDestCityList(citiesWithAll)
        setSelDestCity(citiesWithAll[0])
    
        const branches = destBranchList.filter(
          (b) => b.DestinationStateID === val.DestinationStateID
        )
        const branchesWithAll = [
          {
            DestinationStateID: val.DestinationStateID,
            DispatchedToCityIDFilter: 0,
            DispatchedToBranchIDFilter: 0,
            DispatchedToBranchFilter: 'All',
          },
          ...branches,
        ]
        setFilterdDestBranchList(branchesWithAll)
        setSelDestBranch(branchesWithAll[0])
      }
    
      const handleDestCityChange = (val) => {
        setSelDestCity(val)
    
        // All selected
        if (val.DispatchedToCityIDFilter === 0) {
          const allBranches = destBranchList.filter(
            (b) => b.DispatchedToBranchIDFilter === 0
          )
          setFilterdDestBranchList(allBranches)
          setSelDestBranch(allBranches[0])
          return
        }
    
        const branches = destBranchList.filter(
          (b) => b.DispatchedToCityIDFilter === val.DispatchedToCityIDFilter
        )
        const branchesWithAll = [
          {
            DispatchedToCityIDFilter: val.DispatchedToCityIDFilter,
            DispatchedToBranchIDFilter: 0,
            DispatchedToBranchFilter: 'All',
          },
          ...branches,
        ]
        setFilterdDestBranchList(branchesWithAll)
        setSelDestBranch(branchesWithAll[0])
      }
  return (
     <>
          <Item sx={{ padding: '0' }} className="reports">
            <AcountingHeading reportName={reportName.slice(0, -7)} />
    
            <Box sx={{ ...sx.reportFlex, flexWrap: 'wrap' }}>
              <Item sx={sx.itemsx}>
                <DropDownOA
                  id={'selectCompany'}
                  label={'Select Company'}
                  nextId={'goButton'}
                  prevId={''}
                  defaultvalue={loginData.strCompanyName}
                  disabled={true}
                  width="100%"
                />
              </Item>
              <Item sx={sx.itemsx} className="disabled-wrapper">
                <Button
                  variant="contained"
                  style={{ ...sx.fullHeight, ...sx.novp }}
                  id={'goButton'}
                  className="btn btn-primary"
                  disabled={true}
                >
                  GO
                </Button>
              </Item>
              <Item sx={sx.itemsx} className="input--container" style={{ zIndex: '3' }}>
                <Datepicker
                  label={`Select From Date`}
                  name={'from_date'}
                  id={'fromDate'}
                  nextId={'toDate'}
                  prevId={'goButton'}
                  value={fromDate}
                  maxDate={toDate}
                  dateChange={(date) => {
                    setFromDate(date)
                    focusElemnt('toDate')
                  }}
                  width="100%"
                />
              </Item>
              <Item sx={sx.itemsx} className="input--container" style={{ zIndex: '3' }}>
                <Datepicker
                  label={`Select To Date`}
                  name={'to_date'}
                  id={'toDate'}
                  nextId={'goButton'}
                  prevId={'fromDate'}
                  value={toDate}
                  minDate={fromDate}
                  dateChange={(date) => {
                    setToDate(date)
                    focusElemnt('goButton')
                  }}
                  width="100%"
                />
              </Item>
              <Item sx={sx.itemsx} className="disabled-wrapper">
                <Button
                  variant="contained"
                  style={{ ...sx.fullHeight, ...sx.novp }}
                  id={'goButton'}
                  className="btn btn-primary"
                  onKeyDown={(e) =>
                    navigation3(e, 'SelectSrcState', 'toDate', () => {
                      callFilterAPi()
                    })
                  }
                  onClick={callFilterAPi}
                >
                  GO
                </Button>
              </Item>
              <Item sx={sx.itemsx}>
                <DropDownOA
                  id={'SelectSrcState'}
                  label={'Source State'}
                  nextId={'SelectSrcCity'}
                  prevId={'goButton'}
                  defaultvalue={selState?.SourceState || ''}
                  value={selState?.SourceState || ''}
                  data={stateList}
                  idKey={`SourceStateID`}
                  dataKey={`SourceState`}
                  onSelect={handleStateChange}
                  searchPlaceholder={`Select City`}
                  width="100%"
                  disabled={disableBtn}
                />
              </Item>
              <Item sx={sx.itemsx}>
                <DropDownOA
                  id={'SelectSrcCity'}
                  label={'Source City'}
                  nextId={'SelectSrcBranch'}
                  prevId={'SelectSrcState'}
                  data={filterdCityList}
                  defaultvalue={selCity?.FromCityName || ''}
                  value={selCity?.FromCityName || ''}
                  idKey={`FromCityID`}
                  dataKey={`FromCityName`}
                  onSelect={handleCityChange}
                  isObjArr={true}
                  searchPlaceholder={`Select Branch`}
                  width="100%"
                  disabled={disableBtn}
                />
              </Item>
              <Item sx={sx.itemsx}>
                <DropDownOA
                  id={'SelectSrcBranch'}
                  label={'Source Branch'}
                  nextId={'SelectDestState'}
                  prevId={'SelectSrcCity'}
                  data={filterdBranchList}
                  defaultvalue={selBranch?.BranchName || ''}
                  value={selBranch?.BranchName || ''}
                  idKey={`BranchID`}
                  dataKey={`BranchName`}
                  onSelect={handleSourceBranchChange}
                  isObjArr={true}
                  searchPlaceholder={`Select Branch`}
                  width="100%"
                  disabled={disableBtn}
                />
              </Item>
              <Item sx={sx.itemsx}>
                <DropDownOA
                  id={'SelectDestState'}
                  label={'Destination State'}
                  nextId={'SelectDestCity'}
                  prevId={'SelectSrcBranch'}
                  data={destStateList}
                  defaultvalue={selDestState?.DestinationState || ''}
                  value={selDestState?.DestinationState || ''}
                  dataKey="DestinationState"
                  idKey="DestinationStateID"
                  onSelect={handleDestStateChange}
                  searchPlaceholder="Select State"
                  width="100%"
                  isObjArr
                />
              </Item>
    
              <Item sx={sx.itemsx}>
                <DropDownOA
                  id={'SelectDestCity'}
                  label={'Destination City'}
                  nextId={'SelectDestBranch'}
                  prevId={'SelectDestState'}
                  data={filterdDestCityList}
                  defaultvalue={selDestCity?.DispatchedToCityFilter || ''}
                  value={selDestCity?.DispatchedToCityFilter || ''}
                  dataKey="DispatchedToCityFilter"
                  idKey="DispatchedToCityIDFilter"
                  onSelect={handleDestCityChange}
                  searchPlaceholder="Select City"
                  width="100%"
                  isObjArr
                />
              </Item>
    
              <Item sx={sx.itemsx}>
                <DropDownOA
                  id={'SelectDestBranch'}
                  label={'Destination Branch'}
                  nextId={'PayType'}
                  prevId={'SelectDestCity'}
                  data={filterdDestBranchList}
                  defaultvalue={selDestBranch?.DispatchedToBranchFilter || ''}
                  value={selDestBranch?.DispatchedToBranchFilter || ''}
                  dataKey="DispatchedToBranchFilter"
                  idKey="DispatchedToBranchIDFilter"
                  onSelect={(val) => setSelDestBranch(val)}
                  searchPlaceholder="Select Branch"
                  width="100%"
                  isObjArr
                />
              </Item>
              <Item sx={sx.itemsx}>
                <DropDownOA
                  id={'PayType'}
                  label={'Payment Type'}
                  nextId={'generateButton'}
                  prevId={'SelectDestBranch'}
                  data={paymentTypeList}
                  defaultvalue={selPaymentType?.PaymentType || ''}
                  value={selPaymentType?.PaymentType || ''}
                  dataKey="PaymentType"
                  idKey="PaymentTypeInt"
                  onSelect={(val) => setSelPaymentType(val)}
                  searchPlaceholder="Select Payment Type"
                  width="100%"
                  isObjArr
                />
              </Item>
    
              <Item sx={sx.itemsx} className="disabled-wrapper">
                <Button
                  variant="contained"
                  style={{ ...sx.fullHeight, ...sx.novp }}
                  id={'generateButton'}
                  className="btn btn-primary"
                  onClick={fetchTableData}
                >
                  GENERATE
                </Button>
              </Item>
            </Box>
            {/* {tableData.length ? (
              <TableComponent
                reportName={reportName}
                criteriaHeaders={OGCLFilterHeaders}
                criteriaData={[filterData]}
                tableData={tableData}
                mainHeader={headers}
                // isShowManageColumn={true}
                // manageColumnID={'ogplReportColumns'}
              />
            ) : null} */}
          </Item>
        </>
  )
}

export default OGCLReport
